import { createReducer, on } from '@ngrx/store';
import * as actions from '../../actions';

export interface UIState {
  sidebarOpen: string;
  currentTop: number;
  showSidebar: boolean;
}

export const uiInitialState: UIState = {
  sidebarOpen: 'open',
  currentTop: 0,
  showSidebar: true,
};

// tslint:disable-next-line: variable-name
const _uiReducer = createReducer(
  uiInitialState,

  on(actions.sidebarToggle, (state) => ({
    ...state,
    sidebarOpen: state.sidebarOpen,
  })),
  on(actions.sidebarSetState, (state, { payload }) => ({
    ...state,
    sidebarOpen: payload,
  })),
  on(actions.currentTop, (state, { payload }) => ({
    ...state,
    currentTop: payload,
  })),
  on(actions.showSidebar, (state) => ({
    ...state,
    showSidebar: true,
  })),
  on(actions.hideSidebar, (state) => ({
    ...state,
    showSidebar: false,
  }))
);

export function uiReducer(state, action) {
  return _uiReducer(state, action);
}
